<template>
  <el-button
    class="button-item"
    :style="_buttonStyle"
    :loading="loading"
    :disabled="disabled"
    @click="_click"
  >
    <slot />
  </el-button>
</template>

<script>
export default {
  name: 'ButtonItem',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    buttonStyle: {
      type: Object,
      default: function() {
        return {
          borderRadius: '20px'
        }
      }
    },
    width: {
      type: String,
      default: '132px'
    },
    height: {
      type: String,
      default: '32px'
    },
    type: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    _buttonStyle() {
      const styleMapper = {
        primary: {
          backgroundColor: '#1FA0E8',
          border: '1px solid #1FA0E8'
        }
      }

      if (this.type && styleMapper[this.type]) {
        return Object.assign(
          {
            width: this.width,
            height: this.height,
            lineHeight: this.height
          },
          styleMapper[this.type],
          this.buttonStyle
        )
      } else {
        return Object.assign(
          {
            width: this.width,
            height: this.height,
            lineHeight: this.height
          },
          {
            backgroundColor: '#fff',
            color: '#606266',
            border: '1px solid #DFE3E5'
          },
          this.buttonStyle
        )
      }
    }
  },

  methods: {
    _click() {
      this.$emit('click', 'click')
    }
  }
}
</script>
<style lang='scss' scoped>
::v-deep.button-item.el-button {
	// min-width: 132px;
	border-radius: 20px;
	// height: 32px;
	// line-height: 32px;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	font-size: 14px;
	color: #ffffff;
	border-radius: 20px;
	padding: 0 15px;
}
.el-button + .el-button {
	margin-left: 0;
}

.el-button.is-disabled {
	color: rgba(0,0,0,0.25) !important;
	background: #f9f9f9 !important;
	border: 1px solid #dfe3e5 !important;
}
</style>
